import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { configureIntegration, getAvailableIntegration, getAvailableIntegrations } from './api';
import { AvailableIntegrationResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { useParams } from 'react-router-dom';
import { queryClient } from 'providers/AllProviders';

export function useGetAvailableIntegrations(
  options?: UseQueryOptions<{ data: AvailableIntegrationResponse[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ data: AvailableIntegrationResponse[]; meta: MetaApiResponse }>({
    queryKey: ['integrations'],
    queryFn: () => getAvailableIntegrations(),
    ...options
  });
}

export function useGetAvailableIntegration(options?: UseQueryOptions<AvailableIntegrationResponse, Error>) {
  const { integrationId } = useParams<{ integrationId: string }>();

  return useQuery<AvailableIntegrationResponse>({
    queryKey: ['integration', integrationId],
    queryFn: () => getAvailableIntegration(integrationId!),
    enabled: Boolean(integrationId),
    ...options
  });
}

export function useConfigureIntegration() {
  const { integrationId } = useParams<{ integrationId: string }>();

  return useMutation({
    mutationFn: (payload: { business_ids: number[] }) => configureIntegration(integrationId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['integrations'],
        refetchType: 'active'
      });
      queryClient.invalidateQueries({
        queryKey: ['integration'],
        refetchType: 'active'
      });
    }
  });
}
